import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import InputsFields from "../../helpers/InputFields";
import { CatInputs, ReportPresaVisioneListInputs } from "../../utils/listInputs/ReportPresaVisioneListInputs";
import { useGetCategoriesQuery } from "../../store/services/CategoryService";
import { useGetAgenciesQuery } from "../../store/services/AgencyService";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import SmallLoader from "../main/SmallLoader";

export default function ReportPresaVisioneFilter({ methodParent }: any) {

    const handleSubmitFIlter = (data: any) => {
        methodParent(data)
    }

    const form = useForm();
    const [isOpenFilter, setIsOpenFilter] = useState<boolean>(true);
    const { handleSubmit, watch, setValue } = form;
    const azienda = watch('aziendaId');

    const {data: aziendeList, isLoading: azIsLoading}:any = useGetAgenciesQuery({isSelect: true});
    const {data: categorieList, isLoading}: any = useGetCategoriesQuery(azienda?.value ? {idAzienda: azienda.value, isSelect: true}: skipToken);


    useEffect(() => {
        setValue('categoriaId', '')
    }, [azienda])

    return (
        <div className="bg-white shadow-lg rounded-lg relative">
            {(isLoading || azIsLoading) && <SmallLoader />}
            <div className="flex justify-between items-center p-4" >
                <p>Filtri</p>
                <button onClick={() => setIsOpenFilter(!isOpenFilter)}>
                    {isOpenFilter ? <ChevronUpIcon className="w-5 h-5" /> : <ChevronDownIcon className="w-5 h-5" />}
                </button>
            </div>
            {isOpenFilter && <form onSubmit={handleSubmit(handleSubmitFIlter)} >

                <div className="grid lg:grid-cols-4 sm:grid-cols-2 grid-cols-1 grid-rows-none gap-6 p-4">
                    <InputsFields arrFields={ReportPresaVisioneListInputs(aziendeList?.result)} form={form} />
                    <InputsFields arrFields={CatInputs(categorieList?.result)} form={form} />


                    <div className="col-span-2 flex items-center justify-end space-x-5 pb-5 w-full px-5">
                        <button type="submit" className="h-10 w-52 bg-[#064e3b] text-white rounded-lg px-10 text-[15px]">
                            Download report
                        </button>
                    </div>
                </div>

            </form>}
        </div>
    )
}